(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('dashboardPlaceholder', ["path", function (path) {
        var zeroCounts = false;
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('dashboard/dashboard-placeholder').template('dashboard-placeholder'),
            scope: {},
            link: function ($scope, element, attrs) {
            }
        };
    }]);
}());